<script setup lang="ts">
import { inject, onMounted, onUnmounted, watch, type Ref, toRef } from 'vue'
import { Tabs } from '@ark-ui/vue'
import type { UiTabItemMeta } from './UiTabs.vue'

export interface UiTabsItemProps {
    value: string
    label: string
    count?: number
    disabled?: boolean
}

const props = withDefaults(defineProps<UiTabsItemProps>(), {
    disabled: false,
})

const registerItem = inject<(item: UiTabItemMeta) => void>('UiTabs:registerItem')
const unregisterItem = inject<(value: string) => void>('UiTabs:unregisterItem')

function register() {
    registerItem?.({
        value: props.value,
        label: props.label,
        count: props.count,
        disabled: props.disabled,
    })
}

onMounted(() => {
    register()
})

// Re-register when props change
watch(() => [props.label, props.count, props.disabled], () => {
    register()
}, { deep: true })

onUnmounted(() => {
    unregisterItem?.(props.value)
})
</script>

<template>
    <Tabs.Content :value="props.value" class="block">
        <slot />
    </Tabs.Content>
</template>
